import { Inicio } from "@/contexts/home/pages/Inicio";
import { Route } from "react-router";

// As rotas são renderizadas dentro do layout autenticado em app/routes.tsx.
// Retorna um Fragment (e não um componente) porque <Routes> só aceita
// <Route> ou Fragment como filhos diretos.
export function homeRoutes() {
  return (
    <>
      <Route path="/inicio" element={<Inicio />} />
    </>
  );
}
